import React from 'react';
import './Footer.css';
import Logo from '../../assets/TubeStampLogo.svg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} All Rights Reserved.</span>
        <a href="#" className="footer-link">Privacy Policy</a>
      </div>
    </footer>
  );
};

export default Footer;


